import { render } from "./resetpassword.vue?vue&type=template&id=944ea81a&scoped=true"
import script from "./resetpassword.vue?vue&type=script&lang=js"
export * from "./resetpassword.vue?vue&type=script&lang=js"

import "./resetpassword.vue?vue&type=style&index=0&id=944ea81a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\tap-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-944ea81a"]])

export default __exports__